module.exports = __webpack_public_path__ + "img/9.7eb67c25.png";